<style lang="stylus">
        .Floatmenu-container
            position fixed
            right 26px
            top 38%
            transform translateY(-50%)
            background #FFFFFF
            box-shadow 0px 0px 5.00004px rgba(0, 0, 0, 0.1)
            border-radius 4px
            padding 12px 10px 18px
            width 48px
            // height 350px
            z-index 1
            text-align center
            .Floatmenu-menu-vip
                transform translateY(calc(-100% - 15px))
                position absolute
                right 0

            .feedback-icon
                display flex
                justify-content center
                align-items center
                width 42px
                height 42px
                margin 0 auto
                background #017fff
                border-radius 50%
                box-shadow 0px 0px 10px rgba(189, 189, 189, 0.5)
                cursor pointer
                img
                    width 24px
            .Floatmenu-menu
                // position absolute
                // bottom 34px
                // left 0
                font-size 12px
                line-height 15px
                margin-bottom 24px
                background #fff
                // width 48px
                // height 178px
                &:last-child
                    margin-bottom 0
                .Floatmenu-menu-item
                    display flex
                    flex-direction column
                    justify-content center
                    align-items center
                    padding-bottom 2px
                    user-select none
                    cursor pointer
                    transition background .2s linear
                    svg
                        padding 8px 6px 4px 6px
                        width 20px
                        height 20px
                        box-sizing content-box
                    img
                        margin-bottom 4px
                    .public-icon-1920
                        width 34px
                    .public-icon-2560
                        width 34px
                        display none
                    &:hover
                        span
                            color #017FFF



            .Floatmenu-nullblock
                height 182px
                margin-bottom 30px
                margin-top 10px
            .Floatmenu-toTop
                // display flex
                // justify-content center
                // align-items center
                // position absolute
                // bottom 0
                // left 0
                // background #fff
                // user-select none
                // cursor pointer
                svg
                    width 18px
                    height 18px
                    transform rotate(180deg)
            .publish
                cursor pointer
                padding 7px 13px 14px 14px
                width 140px
                height 89px
                background #017fff
                border-radius 8px
                display flex
                justify-content space-between
                align-items center
                margin-bottom 10px
                .publish-img
                    width 24px
                &.fit
                    height 60px
                .texts
                    font-weight bold
                    font-size 16px
                    line-height 23px
                    color #fff
                    text-align left
                    hyphens manual

            .Floatmenu-toTop-en
                text-align right
                height 50px
                .top-img
                    width 50px
                    height 50px
            img
                cursor pointer
        .Floatmenu-container-en
            padding 0
            width 140px
            top 80%
            background transparent
            box-shadow unset
        .Floatmenu-container.dark-theme__workbench
                background-color #333333 !important
                .Floatmenu-menu
                    background-color #333333
                    color #fff
    @media (min-width:2560px)
        .public-icon-2560
            display block !important
        .public-icon-1920
            display none
</style>

<template>
    <div
        class="Floatmenu-container"
        :style="`top: ${isPC ? 45 : 54}%`"
        :class="{
            'Floatmenu-container-en': !internal,
            'dark-theme__workbench': isPCDarkMode == 2 && internal,
        }"
    >
        <template v-if="internal">
            <div class="Floatmenu-menu-vip" v-if="showVipTips && !vip">
                <img class="vip-tips" src="@/home/assets/img/floatMenu/vip-tips.svg" @click="toBuy" />
                <img class="vip-close" @click="showVipTips = false" src="@/home/assets/img/floatMenu/vip-close.svg" />
            </div>
            <div class="Floatmenu-menu" @click="showPublishBox(true)">
                <div class="Floatmenu-publish Floatmenu-menu-item">
                    <img class="public-icon-1920" src="@/home/assets/img/floatMenu/publish.png" />
                    <img class="public-icon-2560" src="@/home/assets/img/floatMenu/publish-2k.png" />
                    <span>发布模板</span>
                </div>
            </div>
            <div class="Floatmenu-menu">
                <div
                    title="需求反馈"
                    class="Floatmenu-menu-item"
                    @click="toFeed"
                    @mouseenter="feedbackActive = true"
                    @mouseleave="feedbackActive = false"
                >
                    <img v-if="feedbackActive" src="@/home/assets/img/floatMenu/feedback-active.svg" alt="" />
                    <img v-else-if="!feedbackActive && isPCDarkMode == 2" src="@/home/assets/img/floatMenu/feedback-white.svg" alt="" />
                    <img v-else src="@/home/assets/img/floatMenu/feedback.svg" alt="" />
                    <span>需求反馈</span>
                </div>
            </div>

            <div class="Floatmenu-menu" v-if="internal">
                <div
                    title="移动端"
                    class="Floatmenu-menu-item"
                    @mouseenter="(appActive = true), showAppBox($event)"
                    @mouseleave="(appActive = false), hiddenAppBox($event)"
                >
                    <img v-if="appActive" src="@/home/assets/img/floatMenu/app-active.svg" alt="" />
                    <img v-else-if="!appActive && isPCDarkMode == 2" src="@/home/assets/img/floatMenu/app-white.svg" alt="" />
                    <img v-else src="@/home/assets/img/floatMenu/app.svg" alt="" />
                    <span>移动端</span>
                </div>
            </div>
            <div class="Floatmenu-menu" v-if="internal">
                <div
                    title="小程序"
                    class="Floatmenu-menu-item"
                    @mouseenter="(miniprogramActive = true), showMiniprogram($event)"
                    @mouseleave="(miniprogramActive = false), hiddenMiniprogram($event)"
                >
                    <img v-if="miniprogramActive" src="@/home/assets/img/floatMenu/miniprogram-active.svg" alt="" />
                    <img v-else-if="!miniprogramActive && isPCDarkMode == 2" src="@/home/assets/img/floatMenu/miniprogram-white.svg" alt="" />
                    <img v-else src="@/home/assets/img/floatMenu/miniprogram.svg" alt="" />
                    <span>小程序</span>
                </div>
            </div>

            <div
                class="Floatmenu-menu"
                v-for="(item, index) in menuList"
                @click="openLink(item.url)"
                :key="index"
                :style="{
                    'margin-bottom': !showToTop && index == menuList.length - 1 ? '0' : '24px',
                }"
            >
                <div class="Floatmenu-menu-item" @mouseenter="item.active = true" @mouseleave="item.active = false">
                    <img v-if="item.active" :src="item.activeSvg" alt="" />
                    <img v-else-if="!item.active && isPCDarkMode == 2" :src="item.activeSvgWhite" alt="" />
                    <img v-else :src="item.svg" alt="" />
                    <span :title="$t(item.label)">{{ $t(item.label) }}</span>
                </div>
            </div>
            <div class="Floatmenu-menu" v-show="showToTop">
                <div class="Floatmenu-toTop Floatmenu-menu-item" @click="toTop" @mouseenter="toTopActive = true" @mouseleave="toTopActive = false">
                    <img v-if="toTopActive" src="@/home/assets/img/floatMenu/toTop-active.svg" alt="" />
                    <img v-else-if="!toTopActive && isPCDarkMode == 2" src="@/home/assets/img/floatMenu/toTop-white.svg" alt="" />
                    <img v-else src="@/home/assets/img/floatMenu/toTop.svg" alt="" />
                    <span>置顶</span>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="publish" @click="toPublish" :class="{ fit: lang !== 'en' }" v-if="!isPC && !isTeamsApp">
                <div class="texts" v-html="$t('publishText')"></div>
                <img src="@/home/assets/img/publish-en.svg" class="publish-img" alt="" />
            </div>
            <div class="Floatmenu-toTop-en" @click="toTop">
                <img src="@/home/assets/img/top.png" class="top-img" v-show="showToTop" alt="" />
            </div>

            <fileSelector from="publish" :title="$t('fileSelectorTitle')" @on-ok="openWidthFile" />
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import fileSelector from "./Team/fileSelector.vue";
    @Component({
        components: {
            fileSelector,
        },
    })
    export default class Floatmenu extends Vue {
        showToTop: boolean = false;
        feedbackActive: boolean = false;
        toTopActive: boolean = false;
        miniprogramActive: boolean = false;
        appActive: boolean = false;
        showVipTips: boolean = true;
        menuList: Array<object> = [
            // {
            //     id: 0,
            //     label: 'report',
            //     svg: 'FloatMenu-report',
            //     url: 'https://wj.qq.com/s2/6879905/1994'
            // },
            {
                id: 1,
                label: "download",
                svg: "FloatMenu-download",
                url: "https://www.edrawsoft.cn/edrawmax/",
                active: false,
                activeSvg: require("@/home/assets/img/floatMenu/download-active.svg"),
            },
            {
                id: 2,
                label: "help",
                svg: "FloatMenu-help",
                url: "https://support.qq.com/products/105124?", // 'https://support.qq.com/products/164328'
                active: false,
                activeSvg: require("@/home/assets/img/floatMenu/help-active.svg"),
                activeSvgWhite: require("@/home/assets/img/floatMenu/help-white.svg"),
            },
        ];
        get userInfo() {
            return this.$store.state.userInfo;
        }
        toPublish() {
            if (!this.$validateLogin()) return;
            this.$store.commit("setState", {
                type: "showPublishSelector",
                data: true,
            });
        }
        openWidthFile(fileInfo) {
            let ts: any = this;
            let fileObj = "obj=" + fileInfo.obj;
            window.openPlus(window.location.origin + ts.$router.options.base + "app.html?" + ts.$zipFileName(fileObj) + "#publish");
        }
        toBuy() {
            this.$openBuyPage();
        }
        openLink(url) {
            let ts: any = this;
            let win: any = window;
            let qts;
            if (win.$qt) {
                let data = JSON.parse(win.userData);
                win.$qt.jsCallOpenUrl(
                    url +
                        `?platform=${data.platform}&lang=${data.lang}&v=${data.version}&custom=${encodeURIComponent(
                            btoa(
                                JSON.stringify({
                                    id: this.userInfo.user_id,
                                    token: this.userInfo.token,
                                })
                            )
                        )}`
                );
            } else {
                window.open(url);
            }
        }
        showPublishBox(v) {
            if (!this.$validateLogin()) return;
            this.$store.commit("setState", {
                type: "showPublish",
                data: v,
            });
        }
        toFeed() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "feedback",
            });
        }
        toTop() {
            let targetDom = document.querySelector(".store-box");
            targetDom.scroll = (e) => {
                e.preventDefault();
            };
            const scrollToTop = () => {
                const scrollTop = targetDom.scrollTop;
                if (scrollTop > 0) {
                    window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
                    targetDom.scrollTo(0, scrollTop - scrollTop / 8);
                } else {
                    window.cancelAnimationFrame(window["scrollTopID"]);
                    window["scrollTopID"] = null;
                    targetDom.scroll = null;
                }
            };
            window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
        }
        showScrollBtn(e) {
            if (e.target.scrollTop <= 400) {
                this.showToTop = false;
            } else {
                this.showToTop = true;
            }
        }
        hiddenMiniprogram() {
            this.$store.commit("setPromotionBox", {
                show: false,
            });
        }
        showMiniprogram(e) {
            let rect = e.target.getBoundingClientRect();
            let direction = 2;
            this.$store.commit("setPromotionBox", {
                show: true,
                type: "mini",
                left: rect.x - 12,
                top: rect.y,
                direction: direction,
            });
        }
        showAppBox(e) {
            let rect = e.target.getBoundingClientRect();
            let direction = 2;
            this.$store.commit("setPromotionBox", {
                show: true,
                type: "app",
                left: rect.x - 12,
                top: rect.y,
                direction: direction,
            });
        }
        hiddenAppBox(e) {
            this.$store.commit("setPromotionBox", {
                show: false,
            });
        }

        mounted() {
            let targetDom = document.querySelector(".store-box");
            targetDom.addEventListener("scroll", this.showScrollBtn);
            const query = location.search && new URLSearchParams(location.search.slice(1));
            const isHW = query && query.get("hwpad");
            if (this.isPC) {
                this.menuList = [
                    // {
                    //     id: 0,
                    //     label: 'report',
                    //     svg: 'FloatMenu-report',
                    //     url: 'https://wj.qq.com/s2/6879905/1994'
                    // },
                    {
                        id: 2,
                        label: "help",
                        // svg: 'FloatMenu-help',
                        svg: require("@/home/assets/img/floatMenu/help.svg"),
                        url: "https://www.edrawmax.cn/feedback/pc/post",
                        active: false,
                        activeSvg: require("@/home/assets/img/floatMenu/help-active.svg"),
                        activeSvgWhite: require("@/home/assets/img/floatMenu/help-white.svg"),
                    },
                ];
            } else {
                this.menuList = [
                    // {
                    //     id: 0,
                    //     label: 'report',
                    //     svg: 'FloatMenu-report',
                    //     url: 'https://wj.qq.com/s2/6879905/1994'
                    // },
                    {
                        id: 1,
                        label: "download",
                        // svg: 'FloatMenu-download',
                        svg: require("@/home/assets/img/floatMenu/download.svg"),
                        url: "https://www.edrawsoft.cn/edrawmax/",
                        active: false,
                        activeSvg: require("@/home/assets/img/floatMenu/download-active.svg"),
                    },
                    {
                        id: 2,
                        label: "help",
                        // svg: 'FloatMenu-help',
                        svg: require("@/home/assets/img/floatMenu/help.svg"),
                        url: "https://www.edrawmax.cn/feedback/web/help/",
                        active: false,
                        activeSvg: require("@/home/assets/img/floatMenu/help-active.svg"),
                        activeSvgWhite: require("@/home/assets/img/floatMenu/help-white.svg"),
                    },
                ];
            }
            if (isHW) {
                this.menuList = this.menuList.filter((item: any) => {
                    return item.label != "help";
                });
            }
        }
        beforeDestroy() {
            let targetDom = document.querySelector(".store-box");
            targetDom && targetDom.removeEventListener("scroll", this.showScrollBtn);
        }
    }
</script>
<i18n>
{
  "zh": {
    "report": "问卷调查",
    "download": "客户端",
    "help": "意见反馈",
    "publishText": "发布",
    "fileSelectorTitle": "选择文件"
  },
  "es": {
    "report": "Cuestionario",
    "download": "Cliente ",
    "help": "Respuesta",
    "publishText": "Publicidad",
    "fileSelectorTitle": "Seleccionar un documento"
  },
  "jp": {
    "report": "アンケート",
    "download": "クライアント",
    "help": "フィードバック",
    "publishText": "投稿",
    "fileSelectorTitle": "ファイル選択"
  },
  "fr": {
    "report": "Questionnaire",
    "download": "Client",
    "help": "Retour d'information",
    "publishText": "Publier",
    "fileSelectorTitle": "Sélectionnez un document"
  },
  "pt": {
    "report": "Questionário",
    "download": "Cliente",
    "help": "Comentários",
    "publishText": "Publicar",
    "fileSelectorTitle": "Selecione um documento"
  },
  "de": {
    "report": "Umfrage ",
    "download": "Client",
    "help": "Feedback",
    "publishText": "Veröffent&hyphen;lichen",
    "fileSelectorTitle": "Wählen Sie ein Dokument aus"
  },
  "it": {
    "report": "Questionario",
    "download": "Cliente",
    "help": "Risposta",
    "publishText": "Pubblica",
    "fileSelectorTitle": "Seleziona un documento"
  },
  "en": {
    "report": "Questionnaire",
    "download": "Client End",
    "help": "Feedback",
    "publishText": "Publish your diagram",
    "fileSelectorTitle": "Select File"
  },
  "tw": {
    "report": "問卷調查",
    "download": "客戶端",
    "help": "意見反饋",
    "publishText": "發佈",
    "fileSelectorTitle": "選擇文件"
  },
  "kr": {
    "report": "질문 사항",
    "download": "클라이언트",
    "help": "피드백",
    "publishText": "나의",
    "fileSelectorTitle": "문서 선택"
  },
  "id": {
    "report": "Kuesioner",
    "download": "Klien Akhir",
    "help": "Umpan Balik",
    "publishText": "Terbitkan diagram Anda",
    "fileSelectorTitle": "Pilih File"
  }
}
</i18n>
